import { useEffect, useState } from 'react';
import axiosInstance from '../../../utils/axiosConfig';

// Cache a nivel de modulo: /api/empleados es pesado (fotos, equipos) y el
// editor de plantillas lo necesita en cada fila del picker.
let cache = null;
let enVuelo = null;

const cargar = () => {
  if (cache) return Promise.resolve(cache);
  if (!enVuelo) {
    enVuelo = axiosInstance
      .get('/api/empleados')
      .then(({ data }) => {
        cache = (data || []).map((e) => ({
          id: e.id,
          nombre: e.nombre || e.nombre_completo || '',
          cargo: e.cargo || '',
          departamento: e.departamento || '',
          correo: e.correo || '',
        }));
        return cache;
      })
      .finally(() => {
        enVuelo = null;
      });
  }
  return enVuelo;
};

const useEmpleados = () => {
  const [empleados, setEmpleados] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    let vivo = true;
    cargar()
      .then((lista) => vivo && setEmpleados(lista))
      .catch((err) => console.error('Error cargando empleados:', err))
      .finally(() => vivo && setLoading(false));
    return () => {
      vivo = false;
    };
  }, []);

  return { empleados, loading };
};

export default useEmpleados;
